import { state, stateOptions } from "Models/Enums";
import { ComboboxOption } from "Views/Components/Combobox/Combobox";

/**
 * Gets the list of selectable business entities as combo box options
 */
function getStateOptions(): ComboboxOption<state>[] {

	return (Object.keys(stateOptions) as [state])
		.map<ComboboxOption<state>>(value => {
			return {
				display: value === 'NONE' ? 'Select Jurisdiction' : stateOptions[value],
				value: value,
			};
		});
}

export function isTypeOfState(value: string): value is state {
	return ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].includes(value);
}

export const LocationUtil = {
	getStateOptions: getStateOptions,
	isTypeOfState: isTypeOfState
}